<template>
  <!-- <v-container v-if="loading">
    <LoadingContainer />
  </v-container>

  <v-container v-else
    class="cts-main-view col-12 transaction-view-container pt-2"
  >
    <TransactionsViewStandard/>
  </v-container> -->

  <v-container class="cts-main-view col-12 transaction-view-container pt-2">
    <TransactionsViewStandard />
  </v-container>
</template>
<script>
import TransactionsViewStandard from "./transactionsView/TransactionsViewStandard.vue";
export default {
  name: "TransactionView",
  components: {
    TransactionsViewStandard,
  },
  data() {
    return {
      loading: true,
    };
  },
 
};
</script>

<style lang="scss">

.text-pee-small {
  font-size: 10px !important;
}
</style>
